import * as Api from './api';

// Create a new stripe checkout session
export async function getCheckoutURL(cart, setCart): Promise<string | null> {
	if (!Object.keys(cart).length) {
		return null;
	}

	const checkoutInfo = await Api.getCheckoutInfo(cart);
	if (!checkoutInfo) {
		return null;
	}
	
	setCart(checkoutInfo.cart);

	if (checkoutInfo.url) {
		return checkoutInfo.url;
	}
	
	// Free &tags can be directly claimed without checking out
	return checkoutInfo.sessionParams.success_url;
}

export function getEarlyBirdCoupon() {
	const stage = process.env.REACT_APP_ENV || 'dev';
	return stage === 'prod' ? '9UhZ6PQO' : '1GqNIQVd';
}